import React from 'react';
import OutlinedButton from '@/components/common/buttons/OutlinedButton';
import { Icon, Text, useDisclosure } from '@chakra-ui/react';
import { FiUserPlus } from 'react-icons/fi';
import SharePopover from './SharePopover.tsx';

interface ShareButtonProps {
	houseId: number;
	style?: React.CSSProperties;
	presentation?: 'default' | 'prominent';
}

/**
 * Share button component that triggers the share popover
 * Positioned in the top-right corner of the dashboard
 */
const ShareButton: React.FC<ShareButtonProps> = ({ houseId, style, presentation = 'default' }) => {
	const { open, onOpen, onClose } = useDisclosure();
	const isProminent = presentation === 'prominent';

	return (
		<>
			<OutlinedButton
				onClick={onOpen}
				size="md"
				fontWeight="medium"
				aria-label="Connect"
				minW={{ base: '40px', md: '96px' }}
				w={{ base: '40px', md: 'auto' }}
				h={{ base: '40px', md: undefined }}
				px={{ base: 0, md: 4 }}
				border="none"
				borderColor="transparent"
				bg={isProminent ? 'brand.solid' : 'transparent'}
				color={isProminent ? 'white' : 'primary'}
				_hover={{
					bg: isProminent ? 'brand.800' : 'surface.subtle',
					borderColor: 'transparent',
				}}
				style={style}
			>
				<Icon as={FiUserPlus} boxSize={5} />
				<Text as="span" display={{ base: 'none', md: 'inline' }}>
					Connect
				</Text>
			</OutlinedButton>

			<SharePopover isOpen={open} onClose={onClose} houseId={houseId} suggestContacts />
		</>
	);
};

export default ShareButton;
